import classNames from 'classnames';
import { Col } from 'react-bootstrap';
import { FormCheckbox } from '@praktio/common-ui';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import FormSection from '../FormSection/FormSection';
import LoadingErrorBoundaryRTK from '../../ui/LoadingErrorBoundaryRTK/LoadingErrorBoundaryRTK';

import { IconTooltipProps } from '../../ui/IconTooltip/IconTooltip';
import { CourseName } from '../../admin/GeneralReport/TableSummaryReport/TableSummaryReport.types';

import './ActiveCourses.scss';

type Props = {
  className?: string;
  courses?: CourseName[];
  deselectedCourses?: string[];
  error?: FetchBaseQueryError;
  formError?: string;
  isLoading: boolean;
  noCoursesSelected: boolean;
  noSubheader?: boolean;
  noTooltip?: boolean;
  onClearSelectClick: () => void;
  onCourseClick: (courseId: string) => void;
};

const ActiveCourses = ({
  className,
  courses,
  deselectedCourses,
  error,
  formError,
  isLoading,
  noCoursesSelected,
  noSubheader,
  noTooltip,
  onClearSelectClick,
  onCourseClick,
}: Props) => {
  const hasCourses = courses && courses.length;
  const btnText = noCoursesSelected ? 'Select All' : 'Clear All';
  const subheader = noSubheader ? '' : 'Select which courses appear in your reports.';

  const tooltip = {
    id: 'tooltip-teams',
    icon: 'help',
    placement: 'right',
    text: 'Courses assigned to selected teams',
  } as IconTooltipProps;

  return (
    <FormSection
      className={classNames('ActiveCourses', className)}
      subheader="Courses"
      info={subheader}
      tooltip={noTooltip ? undefined : tooltip}
    >
      <LoadingErrorBoundaryRTK error={error as FetchBaseQueryError} isLoading={isLoading}>
        {hasCourses ? (
          <>
            <Col key="clear-all" xs={4} className="text-left">
              <div className="clear-all" onClick={onClearSelectClick}>
                <span>{btnText}</span>
              </div>
            </Col>

            <ul>
              {courses?.map((course) => (
                <li key={course._id}>
                  <FormCheckbox
                    id={course._id}
                    label={course.title}
                    checked={!deselectedCourses?.includes(course._id)}
                    onChange={() => onCourseClick(course._id)}
                  />
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p>No courses found.</p>
        )}

        {!!formError && <div className="PraktioFeedback invalid-feedback">{formError}</div>}
      </LoadingErrorBoundaryRTK>
    </FormSection>
  );
};

export default ActiveCourses;
